import { ArrowRightOutlined } from '@ant-design/icons';
import Image from 'next/image';

import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import { getBusinessHost } from '@/shared/app-common';
import { useTranslation } from 'next-i18next';

export type StopYourLeadsType = 'landing' | 'result';
export default function StopYourLeads({ type, sectionGuide }: { type: StopYourLeadsType; sectionGuide: any }) {
  const isLanding = type == 'landing';
  console.log(sectionGuide, '=a');

  const businessHost = getBusinessHost();
  const { t } = useTranslation();
  const bulletPoints = [
    t('Export history and task tracking'),
    t('Higher limits for large exports'),
    t('Built for teams and high-volume workflows'),
    t('100k+ leads scanned with 95% data accuracy'),
  ];

  return (
    <section className="px-4 max-w-[1260px] mx-auto pt-14 lg:py-20">
      <div
        className={cn('relative overflow-hidden rounded-[20px] bg-cover bg-center', {
          'bg-no-repeat bg-cover bg-center bg-[url(/images/toolkit/bg.png)]': isLanding,
          'bg-[#F8FAFF] border': !isLanding,
        })}
      >
        <div className="relative grid items-start gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 p-6 lg:p-12 min-h-[420px] lg:pb-14">
          <div className="space-y-6 z-[10]">
            <h2
              className={cn('text-[28px] leading-[1.25] font-bold lg:text-[36px]', {
                'text-white': isLanding,
                'text-[#1B1716]': !isLanding,
              })}
            >
              {sectionGuide?.title}
            </h2>
            <p
              className={cn('text-[15px] lg:text-base leading-[1.6] max-w-[540px]', {
                'text-white/85': isLanding,
                'text-[#1B1716]': !isLanding,
              })}
            >
              {sectionGuide?.desc}
            </p>
            <div className="space-y-3">
              {sectionGuide?.cards?.map((item: any, index: number) => (
                <div
                  key={index}
                  className={cn('flex items-center gap-3 text-sm lg:text-base leading-[1.5]', {
                    'text-white': isLanding,
                    'text-[#1B1716]': !isLanding,
                  })}
                >
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white/10 text-[#7AE2FF] shadow-[0_0_0_1px_rgba(255,255,255,0.08)]">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="8" fill="#725CFF" />
                      <path
                        d="M3 7.69231L6.80952 12L13 5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <h3
                    className={cn('flex items-center gap-3 text-sm lg:text-base leading-[1.5]', {
                      'text-white': isLanding,
                      'text-[#1B1716]': !isLanding,
                    })}
                  >
                    {item.title}
                  </h3>
                </div>
              ))}
            </div>
            <div className="space-y-2 pt-2">
              <Link href={`${businessHost}${isLanding ? '/pricing' : ''}`} target="_blank">
                <Button className="h-[46px] w-full lg:w-fit px-5 text-base font-semibold text-white bg-gradient-to-r from-[#5D5FEF] via-[#6E74FF] to-[#4C68FF] shadow-[0_14px_32px_rgba(93,95,239,0.55)] hover:opacity-95 transition">
                  {sectionGuide?.buttonText}
                  <ArrowRightOutlined className="ml-2" />
                </Button>
              </Link>
            </div>
          </div>

          <div className=" lg:max-w-[520px] w-fit absolute bottom-0 right-0 ">
            <Image
              src={sectionGuide?.imgPath}
              alt="Stop Losing Your Leads"
              width={840}
              height={640}
              className="relative z-[1] lg:w-full w-[150px] h-auto rounded-[18px]"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}
